// src/kiosk/qr-payload.ts
var KIOSK_QR_TIME_STEP_SECONDS = 30;
var KIOSK_QR_PAYLOAD_VERSION = "v1";
var KIOSK_QR_PAYLOAD_REGEX = /^(?:(v1)\.)?([0-9a-f-]{36})\.([0-9a-f-]{36})\.(\d+)\.([A-Za-z0-9_-]+)$/;
var parseKioskQrPayload = (payload) => {
  const match = payload.match(KIOSK_QR_PAYLOAD_REGEX);
  if (!match) return null;
  const [, version, playerID, institutionID, timeStepStr, signature] = match;
  return {
    version: version === "v1" ? "v1" : "legacy",
    playerID,
    institutionID,
    timeStep: Number(timeStepStr),
    signature
  };
};
var buildKioskQrSigningPrefix = (playerID, institutionID, timeStep) => `${playerID}.${institutionID}.${timeStep}`;
var formatKioskQrPayload = (playerID, institutionID, timeStep, signatureB64u) => `${KIOSK_QR_PAYLOAD_VERSION}.${buildKioskQrSigningPrefix(
  playerID,
  institutionID,
  timeStep
)}.${signatureB64u}`;
var computeKioskQrTimeStep = (nowMs = Date.now()) => Math.floor(nowMs / 1e3 / KIOSK_QR_TIME_STEP_SECONDS);
var acceptedKioskQrTimeSteps = (nowMs = Date.now()) => {
  const current = computeKioskQrTimeStep(nowMs);
  return [current - 1, current, current + 1];
};
export {
  KIOSK_QR_PAYLOAD_REGEX,
  KIOSK_QR_PAYLOAD_VERSION,
  KIOSK_QR_TIME_STEP_SECONDS,
  acceptedKioskQrTimeSteps,
  buildKioskQrSigningPrefix,
  computeKioskQrTimeStep,
  formatKioskQrPayload,
  parseKioskQrPayload
};
//# sourceMappingURL=index.js.map